import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import OrderStageAnalytic from "./components/OrderStageAnalytic.jsx";
import OrderByStage from "./components/OrderByStage.jsx";
import CommodityWiseOrders from "./components/Commodity.jsx";
import ReviewReportsStatus from "./components/ReviewReportsStatus.jsx";
import LabDashboardFilter from "./components/LabDashboardFilter.jsx";
import RejectedOrders from "./components/RejectedOrders.jsx";
import DisputeAnalysis from "./components/DisputeAnalysis.jsx";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { actions, reducer, sliceKey } from "./slice";
import { labDashboardSaga } from "./saga";
import * as selectors from "./selectors";

function LabDashboard() {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: labDashboardSaga });

  const location = useLocation();
  const history = useHistory();
  const {
    selectedCommoditiesFilter,
    dateRangeFilter,
    selectedDatePeriodFilter,
  } = location.state || {};

  const dispatch = useDispatch();

  const commodities = useSelector(selectors.selectCommodities);

  const [selectedDatePeriod, setSelectedDatePeriod] = useState(
    selectedDatePeriodFilter || "all_time"
  );
  const [selectedCommodities, setSelectedCommodities] = useState(
    selectedCommoditiesFilter || []
  );
  const [dateRange, setDateRange] = useState(
    dateRangeFilter || {
      startDate: null,
      endDate: null,
    }
  );

  useEffect(() => {
    dispatch(actions.fetchCommodities());
  }, [dispatch]);

  useEffect(() => {
    // Clear location state when filters change manually
    if (location.state) {
      history.replace(location.pathname);
    }
  }, [
    selectedDatePeriod,
    selectedCommodities,
    dateRange,
    location.state,
    location.pathname,
    history,
  ]);

  return (
    <>
      <div className="labOrdersListingHeader">
        <p style={{ fontSize: "18px", fontWeight: "bold" }}>
          Analytics Dashboard
        </p>
      </div>
      <LabDashboardFilter
        commodities={commodities}
        selectedDatePeriod={selectedDatePeriod}
        setSelectedDatePeriod={setSelectedDatePeriod}
        selectedCommodities={selectedCommodities}
        setSelectedCommodities={setSelectedCommodities}
        dateRange={dateRange}
        setDateRange={setDateRange}
      />
      <OrderStageAnalytic
        dateRange={dateRange}
        selectedCommodities={selectedCommodities}
      />
      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col span={12}>
          <OrderByStage
            dateRange={dateRange}
            selectedCommodities={selectedCommodities}
          />
        </Col>
        <Col span={12}>
          <CommodityWiseOrders
            dateRange={dateRange}
            selectedDatePeriod={selectedDatePeriod}
            selectedCommodities={selectedCommodities}
          />
        </Col>
      </Row>
      <Row gutter={[24, 24]} style={{ marginTop: 24 }}>
        <Col span={12}>
          <RejectedOrders
            dateRange={dateRange}
            selectedCommodities={selectedCommodities}
          />
        </Col>
        <Col span={12}>
          <DisputeAnalysis
            dateRange={dateRange}
            selectedCommodities={selectedCommodities}
          />
        </Col>
      </Row>
      <ReviewReportsStatus
        dateRange={dateRange}
        selectedCommodities={selectedCommodities}
      />
    </>
  );
}

export default LabDashboard;
